import { render } from "./ProductorList.vue?vue&type=template&id=0ce9d102&ts=true"
import script from "./ProductorList.vue?vue&type=script&lang=ts"
export * from "./ProductorList.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__